<template>
    <div
        ref="root"
        class="overflow-hidden transition-ease"
        :style="{
            maxHeight: props.isExpanded ? `${maxHeight}px` : '0px',
            opacity: props.isExpanded ? '1' : '0',
            pointerEvents: props.isExpanded ? 'auto' : 'none',
        }"
        :aria-hidden="!isExpanded"
    >
        <div ref="inner">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, nextTick } from 'vue';

interface Props {
    isExpanded?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    isExpanded: false,
});

const root = ref<HTMLElement | null>(null);
const inner = ref<HTMLElement | null>(null);
const maxHeight = ref(0);

const measure = () => {
    if (!inner.value) return;
    maxHeight.value = inner.value.scrollHeight;
};

onMounted(async () => {
    await nextTick();
    measure();
});

watch(
    () => props.isExpanded,
    async () => {
        await nextTick();
        measure();
    }
);
</script>
